import { Typography } from '@workspace/ui/components/Typography';
import { observer } from 'mobx-react-lite';
import { useTranslation } from 'react-i18next';

import { company } from '~/company/Company';

import Icon from '../Icon/Icon';

interface FooterDownloadAppButtonsProps {
  className?: string;
}

const buttonClasses =
  'flex w-full items-center gap-2 rounded-3 border border-navigation-stroke-secondary bg-graphic-regular-white px-3 py-1.5 text-graphic-regular-black transition-opacity hover:opacity-90';

const FooterDownloadAppButtons = observer(
  ({ className }: FooterDownloadAppButtonsProps) => {
    const { t } = useTranslation();
    const { ios, android } = company.config.appStoreUrl;

    if (!ios && !android) {
      return null;
    }

    return (
      <div className={className}>
        <Typography.Text400Semibold className="block text-navigation-text-primary">
          {t('downloads')}
        </Typography.Text400Semibold>
        <div className="flex w-fit flex-col gap-2 mt-4">
          {ios && (
            <a
              href={ios}
              target="_blank"
              rel="noopener noreferrer"
              className={buttonClasses}
            >
              <Icon type="apple" size={24} className="shrink-0" />
              <span className="flex flex-col whitespace-nowrap leading-tight">
                <Typography.Text100Regular>
                  {t('downloadOn')}
                </Typography.Text100Regular>
                <Typography.Text200Medium>App Store</Typography.Text200Medium>
              </span>
            </a>
          )}
          {android && (
            <a
              href={android}
              target="_blank"
              rel="noopener noreferrer"
              className={buttonClasses}
            >
              <Icon type="gplay" size={24} className="shrink-0" />
              <span className="flex flex-col whitespace-nowrap leading-tight">
                <Typography.Text100Regular>
                  {t('getOn')}
                </Typography.Text100Regular>
                <Typography.Text200Medium>Google Play</Typography.Text200Medium>
              </span>
            </a>
          )}
        </div>
      </div>
    );
  },
);

export default FooterDownloadAppButtons;
